/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { decode } from 'he';

const Result = ({ entry }) => (
  <li className="planning-scenario-item">
    <span className="planning-scenario-item--title">{decode(entry.post_title)}</span>
    {entry.category !== null && (
      <span className="planning-scenario-item--category">{decode(entry.category.name)}</span>
    )}
    <a href={entry.link}>
      <span>View scenario</span>
      <i className="icon icon-arrow-right" />
    </a>
  </li>
);

export default Result;
